module.exports = __webpack_public_path__ + "images/emoji/a.cd8ab6ea066363baf62e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/a.png
// module id = 6hO8
// module chunks = 2